<app-media-block contentType="gps-only" [mediaForm]="mediaBlockFormGroup" />
<app-information-block contentType="gps-only" [informationForm]="informationBlockFormGroup" />
<app-publication-block contentType="gps-only" [publicationForm]="publicationBlockFormGroup" />